module.exports = __webpack_public_path__ + "static/ds-logo-a0e86aebb81555d46c4449598d873483.svg";